import { all, apply, select, takeEvery } from 'redux-saga/effects';

export function* sendEvent({ payload }) {
    yield apply(window, window.ga, ['send', 'event'].concat(payload));
}

export function* setUserId() {
    let user = yield select(state => state.user);
    yield apply(window, window.ga, ['set', 'userId', user.member_uuid]);
}

export function* root() {
    yield all([
        takeEvery('ga:event', sendEvent),
        takeEvery('user:logged-in', setUserId),
    ]);
}
